"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var end2end_1 = require("@hudled/end2end");
var material_1 = require("@mui/material");
var react_1 = __importDefault(require("react"));
var Button_1 = __importDefault(require("atomicComponents/atoms/Buttons/Button"));
var ButtonPrim_1 = require("components/Buttons/ButtonPrim");
var SimplifyFormInput_1 = __importDefault(require("shared/components/Form/HoC/SimplifyFormInput"));
var TextField_1 = __importDefault(require("shared/components/Form/TextField"));
var backend_1 = require("utils/backend");
var SimpleTextField = (0, SimplifyFormInput_1.default)(TextField_1.default);
var CreateXeroAppsPopover = function (_a) {
    var company = _a.company;
    var _b = __read((0, backend_1.useCall)('transactions-createxeroapps', { accFirmId: company.id }), 2), requestAppCreation = _b[0], isRequestingAppCreation = _b[1];
    var _c = __read(react_1.default.useState(3), 2), count = _c[0], setCount = _c[1];
    var _d = __read(react_1.default.useState(null), 2), popover = _d[0], setPopover = _d[1];
    var handleDownloadPopover = function (event) {
        setPopover(popover ? null : event.currentTarget);
    };
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(Button_1.default, __assign({ onClick: handleDownloadPopover, sx: { mr: 1 } }, { children: "Create Apps" })), (0, jsx_runtime_1.jsx)(material_1.Popover, __assign({ open: !!popover, anchorEl: popover, onClose: function () { return setPopover(null); }, anchorOrigin: { vertical: 'bottom', horizontal: 'left' }, transformOrigin: { vertical: 'top', horizontal: 'left' } }, { children: (0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ p: 2, maxWidth: 500 }, { children: ["Count: ", (0, jsx_runtime_1.jsx)(SimpleTextField, { value: count, onChange: function (c) { return setCount(parseInt(c.replace(/\D/g, ''), 10) || 0); } }), (0, jsx_runtime_1.jsx)(material_1.Box, __assign({ display: "flex", alignItems: "center", justifyContent: "space-between", my: 2 }, { children: (0, jsx_runtime_1.jsxs)(ButtonPrim_1.ButtonPrimSm, __assign({ onClick: requestAppCreation({ count: count }), isSending: isRequestingAppCreation }, { children: ["Create ", (0, end2end_1.handlePlural)('xero app')(count)] })) }))] })) }))] }));
};
exports.default = CreateXeroAppsPopover;
